export const VENDORS_ALL = 'VENDORS_ALL';
export const VENDORS_ALL_SUCCESS = 'VENDORS_ALL_SUCCESS';
export const VENDORS_GET = 'VENDORS_GET';
export const VENDORS_GET_SUCCESS = 'VENDORS_GET_SUCCESS';
export const VENDORS_CREATE = 'VENDORS_CREATE';
export const VENDORS_CREATE_SUCCESS = 'VENDORS_CREATE_SUCCESS';
export const VENDORS_UPDATE = 'VENDORS_UPDATE';
export const VENDORS_UPDATE_SUCCESS = 'VENDORS_UPDATE_SUCCESS';
export const VENDORS_DELETE = 'VENDORS_DELETE';
export const VENDORS_DELETE_SUCCESS = 'VENDORS_DELETE_SUCCESS';
export const VENDORS_UPDATE_PAGINATION = 'VENDORS_UPDATE_PAGINATION';